import baseURL from "../../config";
import "./ContractModal.css";

const ContractModal = ({ onClose, statusHistory }) => (
  <div className="modal-overlay">
    <div className="modal-content">
      <h3>Status History</h3>
      {statusHistory.length > 0 ? (
        <ul style={{ listStyleType: "none", padding: "0" }}>
          {statusHistory.map((status, index) => (
            <li key={index} style={{ paddingBottom: "15px", fontSize: "14px" }}>
              <strong>Admin Status:</strong> {status.adminStatus ?? "N/A"} <br />
              <strong>Crewing Agent Status:</strong> {status.crewingAgentStatus ?? "N/A"} <br />
              <strong>Remark:</strong> {status.remark ?? "No remarks"} <br />
              <strong>Created At:</strong> {status.updatedAt ? new Date(status.updatedAt).toLocaleString() : "N/A"} <br />
              <strong>Approved By:</strong> {status.approvedBy ?? "N/A"} <br />

              {/* Display Form I Document Link if Available */}
              {status.formI && status.formI.filePath ? (
                <>
                  <strong>Form I:</strong>{" "}
                  <a
                    href={`${baseURL}/${status.formI.filePath.replace(/\\/g, "/")}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "blue", textDecoration: "underline" }}
                  >
                    View Document
                  </a>
                </>
              ) : (
                <p>No Form I document available</p>
              )}
              <hr />
            </li>
          ))}
        </ul>
      ) : (
        <p>No status history available.</p>
      )}
      
      <button onClick={onClose}>Close</button>
    </div>
  </div>
);

export default ContractModal;
